// extracted by mini-css-extract-plugin
export default {"ordersList":"OrdersList_ordersList__bjrqe","count":"OrdersList_count__+bfGM","orders":"OrdersList_orders__QJGx3"};